import React, { useEffect, useState } from 'react';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Container } from 'react-bootstrap';
import { 
    FormControl,
    Select,
    MenuItem,
    Autocomplete, 
    TextField,
    InputLabel,
} from "@mui/material";
import { get_departments, getDepartmentDistricts } from "../../helper/Api";
import { toast } from "react-toastify";
import { GET_DEPARTMENT_FAIL, GET_DEPARTMENT_START, GET_DEPARTMENT_SUCCESS } from '../../RTK/Slices/DepartmentSlice';
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

const MainFilter = ({
    open, 
    handleClose, 
    type=null, 
    filterPayload={}, 
    handleInput, 
    handleOpen, 
    handleFilterClick, 
    isDepartmentRequired=true,
    setConsolidate
}) => {
    const { authData } = useSelector((state) => state.authData)
    const [t2DepartmentList, setT2DepartmentList] = useState([]);
    const [t3DepartmentList, setT3DepartmentList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [districtsLoading, setDistrictsLoading] = useState(false);
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 900,
        background: "white",
    };
    const dispatch = useDispatch();

    const fetchDepartments = async (level, main=false, parent_department_id=null) => {
        try {
            dispatch(GET_DEPARTMENT_START());
            const departments = await get_departments({ department_level: level, parent_department_id: parent_department_id ||authData.user.department_id });
            if (departments.data.status) {
                dispatch(GET_DEPARTMENT_SUCCESS(departments.data.result))
                if(main) {
                    setDepartmentList(departments.data.result);
                }else {
                    if (level === 'T2') {
                        setT2DepartmentList(departments.data.result);
                    } else if (level === 'T3') {
                        setT3DepartmentList(departments.data.result);
                    }
                }
            }
        } catch (error) {
            dispatch(GET_DEPARTMENT_FAIL('something went wrong'))
            toast.error("Something went wrong!", {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    };

    const bootDepartmentFilterAPIS = async (tier) => {
        try {
            setDepartmentList([]);
            if(tier === 'T2') {
                await fetchDepartments('T2', true);
            }
            if(tier === 'T3') {
                if(authData.user.department_details.department_level === 'T1') {
                    await fetchDepartments('T2');
                } else {
                    await fetchDepartments('T3', true);
                }
            }
            if(tier === 'T4') {
                if(authData.user.department_details.department_level === 'T1') {
                    await fetchDepartments('T2');
                } else if(authData.user.department_details.department_level === 'T2'){
                    await fetchDepartments('T2');
                } else {
                    await fetchDepartments('T4', true);
                }
            }
        } catch (error) {
            toast.error("Something went wrong!", {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    }

    useEffect(() => {
        bootDepartmentFilterAPIS(filterPayload?.tier);
    }, [filterPayload.tier])

    useEffect(() => {
        let cancelled = false;
        const loadDistricts = async () => {
            try {
                setDistrictsLoading(true);
                const response = await getDepartmentDistricts();
                if (cancelled) return;
                if (response?.data?.status) {
                    setDistrictList(response.data.result || []);
                } else {
                    setDistrictList([]);
                }
            } catch (error) {
                if (!cancelled) {
                    setDistrictList([]);
                    toast.error("Failed to load districts", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                if (!cancelled) setDistrictsLoading(false);
            }
        };
        loadDistricts();
        return () => {
            cancelled = true;
        };
    }, []);

    const pushFilterField = (name, value) => {
        if (typeof handleInput === "function") {
            handleInput({ target: { name, value } });
        }
    };

    const handleDistrictChange = (_event, selected) => {
        pushFilterField("district_id", selected?.id ?? "");
        pushFilterField(
            "district_name",
            selected?.district || selected?.name || ""
        );
    };

    const handleTierRadioChange = (e) => {
        handleInput(e);
        pushFilterField("parent_department_id", "");
        pushFilterField("parent_department_name", "");
        pushFilterField("parent_t2_id", "");
        pushFilterField("department_id", "");
    };

    const handleT2DepartmentChange = (e) => {
        const t2Id = e.target.value;
        const t2Name = t2DepartmentList.find((d) => String(d.id) === String(t2Id))?.name || "";
        pushFilterField("parent_t2_id", t2Id);
        pushFilterField("parent_department_name", t2Name);
        pushFilterField("department_id", "");
        if (filterPayload?.tier === "T3") {
            pushFilterField("parent_department_id", t2Id);
            fetchDepartments("T3", true, t2Id);
        } else if (filterPayload?.tier === "T4") {
            pushFilterField("parent_department_id", "");
            fetchDepartments("T3", false, t2Id);
        }
    };

    const handleT3DepartmentChange = (e) => {
        const t3Id = e.target.value;
        const t3Name = t3DepartmentList.find((d) => String(d.id) === String(t3Id))?.name || "";
        pushFilterField("parent_department_id", t3Id);
        pushFilterField("parent_department_name", t3Name);
        pushFilterField("department_id", "");
        fetchDepartments("T4", true, t3Id);
    };

    const handleToggleChange = (e) => {
        let val = filterPayload.consolidate === false ? true : false;
        setConsolidate((prev) => {
            return {
                ...prev,
                consolidate: val
            }
        });
    };

    return (
        <div>
            <div
              onClick={handleOpen}
              role="button"
              tabIndex={0}
              aria-label={open ? "Close filters" : "Open filters"}
              title={open ? "Close filters" : "Open filters"}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleOpen();
                }
              }}
              className="p-3 rounded-circle bg-secondary-100-hover"
              style={{
                height: "60px",
                width: "60px",
                position: "fixed",
                bottom: "20px",
                right: "20px",
                cursor: "pointer",
                display: "grid",
                placeItems: "center",
                boxShadow: "0 4px 25px #00000040",
                zIndex: 5,
              }}
            >
            {
              !open ? 
              <i className="icon-filter_alt text-white"></i> :
              <i className="icon-close_circle_fill text-white"></i>
            }
            </div>
        <Modal
          open={open}
          // onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <>
            <Box sx={style}>
              {/* Header */}
              <div className="bg-secondary-100 fs-16px text-white w-100 gap-2 d-inline-block px-3 py-2 d-flex align-items-center">
                <i
                  className="icon-close_circle_fill cursor-pointer fs-18px"
                  onClick={handleClose}
                ></i>
                <span
                  className="fs-16px fw-500"
                  style={{ letterSpacing: "0.25px" }}
                >
                  Filters
                </span>
              </div>

              {/* multi department filters */}
              {
                (!['ppa_subactivity_utilization', 'consolidatePPAExpenseReport', 'Beneficiary PPA'].includes(type) && authData.user.department_details.is_multi === "1") &&
                <div
                    style={{
                    padding: "16px",
                    overflowY: "auto",
                    flexGrow: 1,
                    }}
                >
                    <div className="d-flex gap-5 align-items-center">
                        <div className="fs-12px pe-5">Tier</div>
                        <div className="d-flex align-items-center gap-4">
                            {(authData.user.department_details.department_level === 'T1' || authData.user.department_details.department_level === 'T2') && (
                                <div className="d-flex gap-1 align-items-center">
                                    <input
                                        type="radio"
                                        name="tier"
                                        id="t2"
                                        value="T2"
                                        checked={filterPayload?.tier === 'T2'}
                                        onChange={handleTierRadioChange}
                                    />
                                    <label htmlFor="t2">T2</label>
                                </div>
                            )}
                            {(authData.user.department_details.department_level === 'T1' || authData.user.department_details.department_level === 'T2' || authData.user.department_details.department_level === 'T3') && (
                                <div className="d-flex gap-1 align-items-center">
                                    <input
                                        type="radio"
                                        name="tier"
                                        id="t3"
                                        value="T3"
                                        checked={filterPayload?.tier === 'T3'}
                                        onChange={handleTierRadioChange}
                                    />
                                    <label htmlFor="t3">T3</label>
                                </div>
                            )}
                            {(authData.user.department_details.department_level === 'T1' || authData.user.department_details.department_level === 'T2' || authData.user.department_details.department_level === 'T3' || authData.user.department_details.department_level === 'T4') && (
                                <div className="d-flex gap-1 align-items-center">
                                    <input
                                        type="radio"
                                        name="tier"
                                        id="t4"
                                        value="T4"
                                        checked={filterPayload?.tier === 'T4'}
                                        onChange={handleTierRadioChange}
                                    />
                                    <label htmlFor="t4">T4</label>
                                </div>
                            )}
                            {
                                (authData.user.department_details.department_level === 'T1' && ['consolidatePPA'].includes(type)) && (
                                    <div className="d-flex gap-1 align-items-center">
                                        <input
                                            type="radio"
                                            name="tier"
                                            id="all"
                                            value="all"
                                        checked={filterPayload?.tier === 'all'}
                                        onChange={handleTierRadioChange}
                                        />
                                        <label htmlFor="all">All</label>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    {
                        isDepartmentRequired &&
                        <div className="d-flex mt-3">
                            {((filterPayload?.tier === "T4" || filterPayload?.tier === "T3") && authData.user.department_details.department_level !== 'T2') && (
                                <>
                                <div className="d-flex align-items-center gap-5 w-50 ">
                                    <div className="d-flex align-items-center w-100 m-0 p-1">
                                        <Autocomplete
                                            fullWidth
                                            options={t2DepartmentList}
                                            getOptionLabel={(option) =>
                                                option?.name || option?.department_name || ""
                                            }
                                            isOptionEqualToValue={(option, value) =>
                                                String(option?.id) === String(value?.id)
                                            }
                                            value={
                                                t2DepartmentList.find(
                                                    (d) =>
                                                        String(d.id) ===
                                                        String(
                                                            filterPayload.parent_t2_id ||
                                                                (filterPayload.tier === "T3"
                                                                    ? filterPayload.parent_department_id || ""
                                                                    : "")
                                                        )
                                                ) || null
                                            }
                                            onChange={(_event, selected) => {
                                                handleT2DepartmentChange({
                                                    target: { value: selected?.id ?? "" },
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select T2 Department"
                                                    placeholder="Type to search department"
                                                    required
                                                />
                                            )}
                                        />
                                    </div>
                                </div>

                                {filterPayload?.tier === "T4" && (
                                    <div className="d-flex align-items-center gap-5 w-50">
                                        <div className="d-flex align-items-center w-100 m-0 p-1">
                                            <Autocomplete
                                                fullWidth
                                                options={t3DepartmentList}
                                                getOptionLabel={(option) =>
                                                    option?.name || option?.department_name || ""
                                                }
                                                isOptionEqualToValue={(option, value) =>
                                                    String(option?.id) === String(value?.id)
                                                }
                                                value={
                                                    t3DepartmentList.find(
                                                        (d) =>
                                                            String(d.id) ===
                                                            String(filterPayload.parent_department_id || "")
                                                    ) || null
                                                }
                                                onChange={(_event, selected) => {
                                                    handleT3DepartmentChange({
                                                        target: { value: selected?.id ?? "" },
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select T3 Department"
                                                        placeholder="Type to search department"
                                                        required
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                )}
                                </>
                            )}
                            </div>
                    }
                    
                    {
                        isDepartmentRequired &&
                        <div className="d-flex mt-3">
                            {
                                filterPayload?.tier && 
                                    <div className="d-flex align-items-center gap-5 w-100 ">
                                        <Autocomplete
                                            fullWidth
                                            options={departmentList}
                                            getOptionLabel={(option) =>
                                                option?.name ||
                                                option?.department_name ||
                                                ""
                                            }
                                            isOptionEqualToValue={(option, value) =>
                                                String(option?.id) === String(value?.id)
                                            }
                                            value={
                                                departmentList.find(
                                                    (d) =>
                                                        String(d.id) ===
                                                        String(filterPayload.department_id || "")
                                                ) || null
                                            }
                                            onChange={(_event, selected) => {
                                                handleInput({
                                                    target: {
                                                        name: "department_id",
                                                        value: selected?.id ?? "",
                                                    },
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Department for filter"
                                                    placeholder="Type to search department"
                                                    required
                                                />
                                            )}
                                        />
                                    </div>
                            }
                        </div>
                    }
                    

                    {/* <div className="border p-2 d-flex gap-1 mt-3">
                    {departmentData?.map(
                        (val, ind) =>
                        val?.selected === false && (
                            <>
                            <span className="fs-12px rounded-4 border py-1 px-2">
                                {val?.name}
                            </span>
                            </>
                        )
                    )}
                    </div> */}

                    {/* <div className="border bg-secondary-20">
                        <span className="fs-12px py-1 px-2">
                            Selected Departments:
                        </span>
                        <div className="p-2 d-flex gap-1">
                            {departmentData?.map(
                            (val, ind) =>
                                val?.selected === true && (
                                <span
                                    className="fs-12px rounded-4 py-1 px-2 d-flex align-items-center gap-1"
                                    style={{ border: "1px solid #5D6BC3" }}
                                >
                                    {val?.name}{" "}
                                    <i className="icon-close_circle_stroke fs-16px"></i>
                                </span>
                                )
                            )}
                        </div>
                    </div> */}
                </div>
              }
                <Container>
                    <Row>
                        {
                            !['Dashboard'].includes(type) &&
                            <Col sm={4} className='mt-2'>
                            <Autocomplete
                                fullWidth
                                options={districtList}
                                loading={districtsLoading}
                                getOptionLabel={(option) =>
                                    option?.district || option?.name || ""
                                }
                                isOptionEqualToValue={(option, value) =>
                                    String(option?.id) === String(value?.id)
                                }
                                value={
                                    districtList.find(
                                        (d) =>
                                            String(d.id) ===
                                            String(filterPayload.district_id || "")
                                    ) || null
                                }
                                onChange={handleDistrictChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="District"
                                        placeholder="Type to search district"
                                        margin="dense"
                                    />
                                )}
                            />
                            </Col>
                        }
                        {
                            (type && !['Beneficiaries','User','Department','Subactivity','Activity','Child Scheme Accounts','Child Bank Accounts','Schemes','Budgets','Budget Reappropriation','Vendor Payment','DBT/Nach'].includes(type)) &&
                                <>
                                    <Col sm={4} className='mt-2'>
                                        <TextField
                                            fullWidth
                                            id="main-filter-from-date"
                                            label="From Date"
                                            type="date"
                                            name="fromDate"
                                            value={filterPayload.fromDate || ""}
                                            onChange={handleInput}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Col>
                                    <Col sm={4} className='mt-2'>
                                        <TextField
                                            fullWidth
                                            id="main-filter-to-date"
                                            label="To Date"
                                            type="date"
                                            name="toDate"
                                            value={filterPayload.toDate || ""}
                                            onChange={handleInput}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Col>
                                </>
                        }
                        {
                            (['consolidatePPA'].includes(type)) && (
                                <>
                                    <Col sm={4} className='mt-2'>
                                        <FormControl fullWidth margin="dense" variant="outlined">
                                            <InputLabel id="main-filter-ppa-mode-label" shrink>
                                                PPA Mode
                                            </InputLabel>
                                            <Select
                                                labelId="main-filter-ppa-mode-label"
                                                id="main-filter-ppa-mode"
                                                name="ppa_mode"
                                                value={filterPayload.ppa_mode ?? ""}
                                                label="PPA Mode"
                                                onChange={handleInput}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>Not Selected</em>
                                                </MenuItem>
                                                <MenuItem value="online">Online</MenuItem>
                                                <MenuItem value="offline">Offline</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col sm={4} className='mt-2'>
                                        <FormControl fullWidth margin="dense" variant="outlined">
                                            <InputLabel id="main-filter-payment-status-label" shrink>
                                                Payment status
                                            </InputLabel>
                                            <Select
                                                labelId="main-filter-payment-status-label"
                                                id="main-filter-payment-status"
                                                name="payment_status"
                                                value={filterPayload.payment_status ?? ""}
                                                label="Payment status"
                                                onChange={handleInput}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>Not Selected</em>
                                                </MenuItem>
                                                <MenuItem value="success">Success</MenuItem>
                                                <MenuItem value="hold">On Hold</MenuItem>
                                                <MenuItem value="failed">Failed</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Col>
                                </>
                            )
                        }
                        {
                            (!['ppa_subactivity_utilization', 'consolidatePPA', 'consolidatePPAExpenseReport', 'Beneficiary PPA'].includes(type)) &&
                            <Col sm={12} className='mt-2'>
                                <TextField 
                                style={{width: "100%"}}
                                id="string-search" 
                                label="Enter here to search" 
                                type="search"
                                name="searchStr"
                                onChange={handleInput} 
                                value={filterPayload?.searchStr || ""}/>
                            </Col>
                        }
                        
                        
                    </Row>
                </Container>
              

              <hr />

              <div>
                <div className="d-flex justify-content-between gap-3 px-2 pb-3">
                  <Button
                    variant="outlined"
                    color="primary"
                    className="fs-14px"
                  >
                    <span className="fs-16px"> Reset Filter </span>{" "}
                  </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        className="fs-14px"
                        onClick={handleFilterClick}
                    >
                    <span className="fs-16px"> Apply Filter </span>{" "}
                  </Button>
                </div>
              </div>
            </Box>
          </>
        </Modal>
      </div>
    )
}

export default MainFilter;